import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import line1 from '../../theme/assets/svg/lp_academy_s6_line1.svg';
import line2 from '../../theme/assets/svg/lp_academy_s6_line2.svg';


const AcademyS6 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}><span>{t('Начните свой путь')}</span> {t('в Академии!')}</div>
                <div className={Styles.posWrap}>
                    <div className={Styles.wayWrap}>
                        <div className={Styles.wayItem}>
                            <div className={Styles.wayItemNumber}>1</div>
                            <div className={Styles.wayItemText}>{t('Создайте себе кошелек')}</div>
                            <div className={Styles.absLine1}>
                                <img src={line1} alt="Line"/>
                            </div>
                        </div>
                        <div className={Styles.wayItem}>
                            <div className={Styles.wayItemNumber}>2</div>
                            <div className={Styles.wayItemText}>{t('Пройдите курс Академии')}</div>
                        </div>
                        <div className={Styles.wayItem}>
                            <div className={Styles.wayItemNumber}>3</div>
                            <div className={Styles.wayItemText}>{t('Получите доступ к Лаунчпаду')}</div>
                            <div className={Styles.absLine2}>
                                <img src={line2} alt="Line"/>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.textWrap}>
                        <div className={`${Styles.noteWrap}`}>
                            <div className={`${Styles.noteItem}`}>{t('Хватит играть в рулетку!')}</div>
                            <div className={`${Styles.noteItem}`}>{t('Инвеструй с умом')}</div>
                        </div>
                        <div
                            className={`${Styles.aboutBtn}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => window.open("https://honee.technology/academy", "_blank", "noopener,noreferrer")}
                        >
                            {t('Записаться в Академию')}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademyS6;




